import React, { FC, useRef } from 'react';

import Button from 'src/common/components/Button';
import Icon from 'src/common/components/IconDS22';
// import useIntersectionObserver from 'src/common/hooks/useIntersectionObserver';
import scrollPageToBottom from 'src/common/utils/scrollPageToBottom';
import useIntersectionObserver from 'src/common/hooks/useIntersectionObserver';
import styles from './ScrollToBottomFAB.module.scss';

type ScrollToBottomFABProps = {
  bottomValue?: number;
};

const ScrollToBottomFAB: FC<ScrollToBottomFABProps> = ({ bottomValue }) => {
  const bottomSentinelRef = useRef<HTMLDivElement>(null);
  const isAtBottom = useIntersectionObserver({ ref: bottomSentinelRef });

  return (
    <>
      <div ref={bottomSentinelRef} />
      {!isAtBottom && (
        <div
          className={styles.root}
          style={bottomValue ? { bottom: `${bottomValue}px` } : undefined}
        >
          <Button
            iconOnly
            classNameModifier="inbox primary-white rounded small shadow"
            type="button"
            onClick={() => scrollPageToBottom('smooth')}
          >
            <Icon id="caret-down" />
          </Button>
        </div>
      )}
    </>
  );
};

export default ScrollToBottomFAB;
